import { Injectable } from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {DataService} from './data.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService implements Resolve<any>{
z:any;
optional:any;
  constructor(private dataa:DataService) { }
  resolve(route:ActivatedRouteSnapshot, state:RouterStateSnapshot): Observable<any>{
    let slash = route.paramMap.get('what');
    let listoredit = route.paramMap.get('listoredit');

    if(listoredit == 'list'){
    console.log('list');
      return this.dataa.returnee(slash);

    }else{
      let name = route.paramMap.get('name');
      this.optional = name.replace(/%2520|%20|%252520|%25252520/g, ' ');
      console.log(this.optional);

      return this.dataa.returnee(slash+"/"+this.optional);
      console.log(this.optional);

    }
  }
}
